import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-03f9d80e")

_pushScopeId("data-v-03f9d80e")
const _hoisted_1 = { class: "notify-url-wrap" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "notify-url-tips" }, "完整地址", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "dialog-tips" }, " APPID，客户密钥，签名密钥，确定系统自动生成 ", -1)
const _hoisted_6 = { class: "footer-action" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "企业开放APPID设置",
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShow = $event)),
    width: "740px",
    "close-on-click-modal": false,
    onClosed: _ctx.handleClose
  }, {
    footer: _withId(() => [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.loading,
          onClick: _ctx.handleValidate
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.formData,
        ref: "formRef",
        rules: _ctx.rules,
        "label-width": "100px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "企业名称",
            prop: "companyUuid"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.companyUuid,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.companyUuid = $event)),
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                "remote-method": _ctx.remoteMethod,
                loading: _ctx.remoteLoading,
                placeholder: "关键搜索选择",
                style: {"width":"100%"}
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.enterpriseOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "回调地址",
            prop: "notifyUrl"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.notifyUrl,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.notifyUrl = $event)),
                  type: "textarea",
                  rows: 5,
                  placeholder: "请输入完整地址"
                }, null, 8, ["modelValue"]),
                _hoisted_2
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "模块",
            prop: "modules"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.formData.modules,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.modules = $event))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moduleOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: item.value,
                      label: item.value
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "status"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.status = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _hoisted_5
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
})